"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var elementIsNotNullOrUndefined = function elementIsNotNullOrUndefined(element) {
  return element != null;
};

var Tabs = function Tabs(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      selected = _ref.selected,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["classes", "children", "selected", "onChange"]);

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), children.filter(elementIsNotNullOrUndefined).map(function (tabItem) {
    var value = tabItem.props.value;
    return _react["default"].cloneElement(tabItem, {
      key: value,
      selected: selected === value,
      onChange: onChange
    });
  }));
};

Tabs.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of Popover component */
  children: _propTypes["default"].node.isRequired,

  /** Sets the selected tab based on the tab's value prop */
  selected: _propTypes["default"].string,

  /** Tabs onChange callback */
  onChange: _propTypes["default"].func
};
Tabs.defaultProps = {
  selected: null,
  onChange: function onChange() {}
};

var _default = (0, _withStyles["default"])(_styles["default"])(Tabs);

exports["default"] = _default;